import * as React from 'react';

export const ContentKitStepperContext = React.createContext<{
    /** Go to the previous step */
    previous?: () => void;
    /** Go to the next step */
    next?: () => void;
    /** Whether the stepper is currently in a transition between steps */
    loading: boolean;
} | null>(null);
